// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__16Kyk","column":"styles_column__336RR","imgWrap":"styles_imgWrap__1I2Ro","textWrap":"styles_textWrap__1e6j1","text":"styles_text__2Uw-m"};